import { InfoCard } from "@introist/react-foundation/v2";

export const CredentialsConfiguredInfoCard = ({ ...rest }) => {
  return <InfoCard {...rest} title="Credentials configured" icon="smile" colorVariant="success" />;
};
